<template>
  <div>
    <nav id="nav" :class="{ 'navbar--color': !changeNavColor }">
      <b-nav
        pills
        align="center"
        id="largeNav"
        fill
        :class="{ 'navbar--color': !changeNavColor }"
      >
        <b-nav-item id="/" to="/">Home</b-nav-item>
        <b-nav-item id="/services" to="/services">Services</b-nav-item>
        <b-nav-item id="/preapproved" to="/preapproved"
          >Get Pre-Approved</b-nav-item
        >
        <b-nav-item id="/inventory" to="/inventory">Inventory</b-nav-item>
        <b-nav-item id="/testimonials" to="/testimonials"
          >Testimonials</b-nav-item
        >
      </b-nav>

      <b-nav id="dropDown" :class="{ 'navbar--color': !changeNavColor }">
        <b-nav-item-dropdown
          id="my-nav-dropdown"
          toggle-class="nav-link-custom"
          right
          :lazy="true"
        >
          <b-dropdown-item to="/">Home</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item to="/services">Services</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item to="/preapproved">Get Pre-Approved</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item to="/inventory">Inventory</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item to="/testimonials">Testimonials</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>
    </nav>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        changeNavColor: true,
        lastScrollPosition: 0,
        currentTab: null,
      };
    },
    methods: {
      createBurgerIcon() {
        let dropdown = document.getElementById("my-nav-dropdown__BV_toggle_");
        let bar = document.createElement("div");
        let bar2 = document.createElement("div");
        let bar3 = document.createElement("div");
        dropdown.appendChild(bar);
        dropdown.appendChild(bar2);
        dropdown.appendChild(bar3);
      },
      onScroll() {
        // Get the current scroll position
        const currentScrollPosition =
          window.pageYOffset || document.documentElement.scrollTop;
        // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
        if (currentScrollPosition < 0) {
          return;
        }
        // Here we determine whether we need to show or hide the navbar
        this.changeNavColor = currentScrollPosition < 1;

        // Set the current scroll position as the last scroll position
        this.lastScrollPosition = currentScrollPosition;
      },
      getSendNavHeight() {
        let navHeight = document.getElementById("nav").clientHeight;
        this.$emit("childToParent", navHeight);
      },
      getAnchorTagClicks() {
        var anchors = document.querySelectorAll("a");

        for (var i = 0; i < anchors.length; i++) {
          anchors[i].addEventListener(
            "click",
            (event) => {
              this.currentTab = event.target.pathname;
              localStorage.currentTab = event.target.pathname;
              var element = document.getElementById(this.currentTab)
                .firstElementChild;
              element.classList.add("active");
            },
            false
          );
        }
      },
      checkLocalStorage() {
        if (localStorage.currentTab) {
          console.log(localStorage.currentTab);
          this.currentTab = localStorage.currentTab;
          var element = document.getElementById(this.currentTab)
            .firstElementChild;
          element.classList.add("active");
        } else {
          this.currentTab = "/";
          var element = document.getElementById(this.currentTab)
            .firstElementChild;
          element.classList.add("active");
        }
      },
    },
    created() {
      if (window.performance) {
        console.info("window.performance works fine on this browser");
      }
      if (performance.navigation.type == 0) {
        if (localStorage.currentTab) {
          localStorage.currentTab = "/";
        }
      }
      console.log(performance.navigation.type);
    },
    mounted() {
      this.getAnchorTagClicks();

      document.addEventListener("DOMContentLoaded", function () {
        this.checkLocalStorage();
      });

      this.createBurgerIcon();

      this.getSendNavHeight();

      window.addEventListener("scroll", this.onScroll, { passive: true });
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.onScroll, { passive: true });
    },
    watch: {
      currentTab() {
        localStorage.currentTab = this.currentTab;
      },
    },
  };
</script>

<style lang="scss">
  @import "../assets/scss/components/navbar/navbar.scss";
</style>

